/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { Box, FormControl, IconButton, MenuItem, Select } from '@mui/material';
import { gridPageSelector, gridPageSizeSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { IconArrowRight, IconArrowLeft, IconArrowRightEnd, IconArrowLeftEnd } from '../../images';
import { GlobalContext } from '../../contexts/globalContext';
import { i18n } from '../../i18n/i18n';

const rowsPerPageOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const CustomPagination = () => {
    const { collectionData } = useContext(GlobalContext);
    const rowsCount = collectionData.rowsCount;
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

    const startIndex = rowsCount ? page * pageSize + 1 : 0;
    const endIndex = (page + 1) * pageSize <= rowsCount ? (page + 1) * pageSize : rowsCount;
    const nextArrowDisabled = endIndex >= rowsCount;
    const BackArrowDisabled = startIndex <= pageSize;

    useEffect(() => {
        try {
            apiRef.current.setPage(collectionData.paginationModel.page);
        } catch (e) {}
    }, [collectionData.paginationModel.page]);

    return rowsCount ? (
        <Box
            sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            data-testid="pagination"
        >
            <Box sx={{ width: '88px' }}>
                <span>{`${startIndex} - ${endIndex} `}</span>
                <span>{`${i18n.translate('of')} ${rowsCount}`}</span>
            </Box>
            <Box sx={{ ml: 1 }}>
                <IconButton
                    className={BackArrowDisabled ? 'fill-svg-children-ms' : 'fill-svg-children-mh'}
                    sx={{ mx: 1 }}
                    disabled={BackArrowDisabled}
                    onClick={() => apiRef.current.setPage(0)}
                >
                    <IconArrowLeftEnd />
                </IconButton>
                <IconButton
                    className={BackArrowDisabled ? 'fill-svg-children-ms' : 'fill-svg-children-mh'}
                    sx={{ mx: 1 }}
                    disabled={BackArrowDisabled}
                    onClick={() => apiRef.current.setPage(page - 1)}
                >
                    <IconArrowLeft />
                </IconButton>
                <IconButton
                    className={nextArrowDisabled ? 'fill-svg-children-ms' : 'fill-svg-children-mh'}
                    sx={{ mx: 1 }}
                    disabled={nextArrowDisabled}
                    onClick={() => apiRef.current.setPage(page + 1)}
                >
                    <IconArrowRight />
                </IconButton>
                <IconButton
                    className={nextArrowDisabled ? 'fill-svg-children-ms' : 'fill-svg-children-mh'}
                    sx={{ mx: 1 }}
                    disabled={nextArrowDisabled}
                    onClick={() => apiRef.current.setPage(Math.round(rowsCount / pageSize))}
                >
                    <IconArrowRightEnd />
                </IconButton>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {' '}
                <FormControl variant="standard">
                    {' '}
                    <Select value={pageSize} onChange={() => {}} disableUnderline>
                        {rowsPerPageOptions
                            .filter((rowAmount, index) => !index || rowsCount + 10 > rowAmount)
                            .map((rowAmount, index) => (
                                <MenuItem
                                    key={index}
                                    value={rowAmount}
                                    onClick={() => {
                                        if (pageSize !== rowAmount) {
                                            collectionData.setPaginationModel((prev) => ({
                                                ...prev,
                                                pageSize: rowAmount,
                                            }));
                                            apiRef.current.setPage(0);
                                        }
                                    }}
                                >
                                    {rowAmount}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <Box sx={{ ml: 1 }}>{i18n.translate('rows per page')}</Box>
            </Box>
        </Box>
    ) : null;
};

export default CustomPagination;
